import { makeAutoObservable } from 'mobx'

/**
 * Opens the global Convert drawer from anywhere in the app, without
 * navigating. The drawer itself is mounted once at the App root.
 */
class ConvertController {
  isOpen = false

  /** Optional preselected source asset for the next open. */
  preferredTicker?: string

  constructor () {
    makeAutoObservable(this)
  }

  open = (preferredTicker?: string): void => {
    this.preferredTicker = preferredTicker
    this.isOpen = true
  }

  close = (): void => {
    this.isOpen = false
    this.preferredTicker = undefined
  }
}

export default new ConvertController()
